import * as React from "react";
import { connect } from "react-redux";
import { Redirect, RouteComponentProps } from "react-router";
import { Action, Dispatch } from "redux";
import { frontEndConfig } from "../../config/config";
import { Pager } from "../../domain/model/common";
import { Project } from "../../domain/model/project";
import { TCompanyWithProjectID } from "../../domain/repository/company_repository";
import { entity } from "../../infra/api/rpc/api";
import { createCustomerEntriesActionCreator } from "../action/customer_entries_action";
import EntriesComponent from "../component/customer/entries/customer_entries";
import {
  createCustomerEntriesDispatcher,
  ICustomerEntriesDispatcher,
} from "../dispatcher/customer_entries_dispatcher";
import { GetEntryProjectsByCustomerRequest } from "../request/entry_request";
import { AppState } from "../store/app_state";
import { AuthState } from "../store/auth_state";
import { CustomerEntriesState } from "../store/customer_entries_state";
import { TPagination } from "../type/common";

const defaultOffset = 12;
const pageRangeDisplayed: number = frontEndConfig.defaultPageRangeDisplayed;

interface IProps extends RouteComponentProps<{}> {
  state: CustomerEntriesState;
  authState: AuthState;
  dispatcher: ICustomerEntriesDispatcher;
}

interface IState {
  isInit: boolean;
}

export class CustomerEntries extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isInit: true,
    };
  }

  public componentDidMount() {
    // 直接アクセスの際のデータ取得
    const params: { activePage: number } = this.helperForSearchPrams(
      this.props.location.search
    );
    this.pushQueryString(params.activePage);
  }

  public componentWillReceiveProps(
    nextProps: Readonly<IProps>,
    nextContext: any
  ): void {
    // URL遷移の際のデータ取得
    if (nextProps.location !== this.props.location) {
      const params: { activePage: number } = this.helperForSearchPrams(
        nextProps.location.search
      );
      const pager: Pager = new Pager(params.activePage, defaultOffset);
      const req: GetEntryProjectsByCustomerRequest =
        new GetEntryProjectsByCustomerRequest();
      req.pager = pager;
      this.props.dispatcher.getEntryList(req);
    }
  }

  public componentDidUpdate(prevProps: IProps, prevState: IState) {
    // init処理の終了
    const isInitFinished: boolean =
      this.state.isInit &&
      !this.props.state.isLoading &&
      prevProps.state.isLoading;
    if (isInitFinished) {
      return this.setState({ isInit: false });
    }
  }

  public render(): JSX.Element {
    const { location, state } = this.props;
    const { isInit } = this.state;
    const { user } = this.props.authState;

    const projects: Project[] = state.projects;
    const projectCount: number = state.projectCount;
    const companiesWithProjectID: TCompanyWithProjectID[] =
      state.companiesWithProjectID;
    const contractIndex = state.contractIndex;

    const totalItemsCount: number = state.projectCount;
    const isLoading: boolean = state.isLoading;
    const itemsCountPerPage: number = defaultOffset;

    const params: { activePage: number } = this.helperForSearchPrams(
      location.search
    );

    const paginationPrams: TPagination = {
      activePage: params.activePage,
      itemsCountPerPage,
      totalItemsCount,
      pageRangeDisplayed,
      onChange: this.handlePageChange,
    };

    if (user!.customer!.type === entity.Customer.Type.Type_Pro) {
      return <Redirect to="/" />;
    }

    return (
      <EntriesComponent
        isInit={isInit}
        isLoading={isLoading}
        projects={projects}
        projectCount={projectCount}
        companiesWithProjectID={companiesWithProjectID}
        paginationPrams={paginationPrams}
        user={user}
        contractIndex={contractIndex}
      />
    );
  }

  private helperForSearchPrams = (
    urlSearchParams: any
  ): { activePage: number } => {
    const params = new URLSearchParams(urlSearchParams);
    let activePage: number = params.get("p") ? Number(params.get("p")) : 1;
    if (Number.isNaN(activePage)) {
      activePage = 1;
    }

    const res: { activePage: number } = {
      activePage,
    };
    return res;
  };

  private pushQueryString = (activePage: number): void => {
    const { location, history } = this.props;
    const params = new URLSearchParams(location.search);
    params.set("p", activePage.toString());
    history.push({
      search: params.toString(),
    });
  };

  private handlePageChange = (pageNumber: number): void => {
    this.pushQueryString(pageNumber);
  };
}

const mapStateToProps = (state: AppState) => {
  return {
    state: state.customerEntriesReducer,
    authState: state.authReducer,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    dispatcher: createCustomerEntriesDispatcher(
      dispatch,
      createCustomerEntriesActionCreator()
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerEntries);



// WEBPACK FOOTER //
// ./src/presentation/container/customer_entries_container.tsx